export const SETTING_GET = 'SETTING_GET';
export const SETTING_EDIT = 'SETTING_EDIT';
